export default "__VITE_ASSET__BAJT5FGO__"